import React, { ReactNode, useState } from "react";
import Sidebar from "./sidebar";
import Header from "./header";

type Props = {
  children: ReactNode;
};
export default function MainLayout({ children }: Props) {
  const [collapsed, setCollapsed] = useState(false);

  // Plain flex row, not antd's <Layout> — antd only switches Layout to a row
  // direction when it detects a real <Layout.Sider> child via internal
  // context; a hand-rolled Sidebar div doesn't qualify, so Layout silently
  // falls back to its own default flex-direction: column (higher-specificity
  // CSS-in-JS, beats a plain Tailwind `flex` class). Sidebar's explicit
  // h-full then claims the whole column, squeezing content to zero height —
  // invisible on desktop, but fine on mobile where Sidebar is display:none
  // and drops out of the flex calculation entirely.
  return (
    <div className="flex h-screen">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex h-full min-w-0 flex-1 flex-col bg-gray-50">
        <div className="sticky top-0 z-40 h-24 shrink-0 border-b border-gray-200 bg-white">
          <Header />
        </div>
        <div className="flex-1 overflow-y-auto p-2 md:p-4">{children}</div>
      </div>
    </div>
  );
}
